import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { rhinebeckConfig } from "./data";

export default function RhinebeckPage() {
  return <CityPageTemplate config={rhinebeckConfig} />;
}